import { render, staticRenderFns } from "./SalesUnit.vue?vue&type=template&id=20cda339&"
import script from "./SalesUnit.vue?vue&type=script&lang=js&"
export * from "./SalesUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports